
import UpdateCustomer from "../../../components/@users/customers/UpdateCustomer";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProfilePage() {

    // return UpdateCustomer({
    //     routeType: routeTypes.customer,
    //     isOwnProfile: true
    // })

    return (
        <UpdateCustomer 
            routeType={routeTypes.customer}
            isOwnProfile={Boolean(true)}
        />
    )
}       